export default __webpack_public_path__ + "static/BASEBALLPEPE-6f15841413c7750c672701d58b7df706.png";